import React from 'react';
import moment from 'moment';

import SVGIcon from 'src/components/svg';
import MediaFiles from './MediaFiles';
import { urlRegx } from 'src/helpers';

// Shared helper: turn URLs in a text into <a> links.
export const renderTextWithLinks = (text) => {
  const str = text == null ? '' : text.toString();
  if (!str) return str;

  const urls = str.match(urlRegx);
  if (!urls || !urls.length) return str;

  const elements = [];
  let count = 0; // running offset: where the last link ended

  urls.forEach((url, i) => {
    const index = str.indexOf(url, count); // search from `count`, not from 0
    if (index === -1) return;

    if (index > count) elements.push(str.substring(count, index));
    elements.push(
      <a
        key={`link-${i}-${index}`}
        href={url.indexOf('http') !== 0 ? 'http://' + url : url}
        rel='noreferrer'
        target='_blank'
        className='mc-pointer mc-color-primary'
        style={{ wordBreak: 'break-all' }}
      >
        {url}
      </a>
    );
    count = index + url.length;
  });

  // Always add the remaining text, even if the last URL was skipped
  if (count < str.length) elements.push(str.substring(count));

  return elements.length ? elements : str;
};

export default class TextItem extends React.PureComponent {
  renderText = () => renderTextWithLinks(this.props.item.text);

  renderTime = () => {
    const { item } = this.props;
    return (
      <div className={'mc-flex-5'}>
        <div className={'mc-send'}>
          <SVGIcon iconname={'send-status-icon'} state={item.state} />
        </div>
        <div className={'mc-time'}>{item.date && moment(item.date).format('hh:mm A')}</div>
      </div>
    );
  };

  render() {
    const { item, side, headerTitle, renderOptions, mediaRerender } = this.props;

    const isShortText =
      !!item.text &&
      item.text.toString().length < 100 &&
      !item.preview &&
      (!item.media || !item.media.length);

    return (
      <>
        <div className={'mc-text-msg mc-' + side}>
          <div className='mc-text-msg-container'>
            {renderOptions}
            <div className={'mc-flex-5-col'}>
              {headerTitle}
              <div className={'mc-flex-15-col'}>
                <MediaFiles item={item} mediaRerender={mediaRerender} />
                {item.text && <pre className={'mc-content'}>{this.renderText()}</pre>}

                {item.preview && item.preview.title && item.previewUrl && (
                  <a
                    href={item.previewUrl}
                    className='mc-user-msg-link-preview'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {item.preview.image && <img src={item.preview.image} />}
                    <div className='mc-user-msg-link-preview-content'>
                      {item.preview.title && (
                        <div className='mc-user-msg-link-preview-title'>
                          <span>{item.preview.title}</span>
                        </div>
                      )}
                      {item.preview.description && (
                        <div className='mc-user-msg-link-preview-description'>
                          <span>{item.preview.description}</span>
                        </div>
                      )}
                    </div>
                  </a>
                )}
              </div>
            </div>
            {isShortText && this.renderTime()}
          </div>
          {!isShortText && <div className='mc-text-msg-time-wrapper'>{this.renderTime()}</div>}
        </div>
      </>
    );
  }
}
